<template>
  <div class="add-friend-item-container">
    <div
      v-if="!noUser && user.uid"
      class="human-container">
      <profile-image
        :src="user.avatar_url"
        :user="user"
        class="human-item__profile-image"/>
      <div class="human-item__info">
        <div class="human-item__name">
          {{ $getUserName(user) }}
        </div>
        <div class="human-item__phone">
          {{phone | formatPhone}}
        </div>
      </div>
    </div>
    <div
      v-if="error"
      class="findUserError">
      <span>{{ errorMessage }}</span>
    </div>
    <div
      v-if="infoMessage"
      class="findUserInfo">
      <span>{{ infoMessage }}</span>
    </div>
    <div class="" v-else-if="noUser">
      <div class="human-item_no-item">
        <img src="../../assets/img/sad.svg" alt="">
        <span class="no-users-text">
          {{ $t('CP.userNotFound') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import ProfileImage from '../ProfileImage/ProfileImage';

export default {
  name: 'AddFriendItem',
  components: {
    ProfileImage,
  },
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    phone: {
      type: String,
      default: '',
    },
    noUser: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    infoMessage: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
  .human-container {
    display: flex;
    flex: 1;
  }

  .human-item__profile-image {
    align-self: center;
  }

  .focused .human-item__profile-image {
    box-shadow: 0 1px 6px rgba(41, 121, 255, 0.61)
  }

  .human-item__name {
    color: var(--text-main-color);
  }

  .human-item__info {
    flex: 1;
    text-align: left;
    margin: 0 10px 0 10px;
  }
  .human-item__phone {
    font-size: 12px;
    font-weight: normal;
    color: rgba(72, 82, 140, 0.6);
  }
  .findUserError {
    margin-top: 20px;
    color: var(--error-red);
  }
  .findUserInfo {
    margin-top: 20px;
    color: var(--text-seccond-color);
  }
  .human-item_no-item {
    padding: 9px 0 0;
  }
  .no-users-text {
    font-size: 1rem;
    color: #ABB1CD;
    font-weight: normal;
    margin: 0 0 0 16px;
  }
</style>
